import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faStar } from '@fortawesome/free-solid-svg-icons';

const Testimonials = () => {
  const testimonials = [
    {
      rating: 5,
      quote: 'Better collaboration with the visibility to see and resolve customer queries — it is a definite game-changer for customer-centric businesses providing excellent customer satisfaction. Shall recommend it for the difference it made in how customers reach for their specific business solutions.',
      author: 'Maryam Amiri',
      title: 'Innovation Evangelist, @V Group Inc.',
      avatar: 'MA',
      color: 'cyan'
    },
    {
      rating: 5,
      quote: 'This wonderful application streamlined customer communications, decreasing customer churn for all our events and tournaments. Routing customer requests to the right vertical, it helped increase our customer outreach. Highly recommend for resolving millions of specific customer queries.',
      author: 'Hossein Shams',
      title: 'Business Analyst, @Tournament Edition',
      avatar: 'HS',
      color: 'emerald'
    },
    {
      rating: 5,
      quote: 'Integrated communications and easy-to-use features helped agents on top of customer query resolution, offering seamless customer experiences. Definitely recommend for maintaining customer relationships and converting prospects to future customers.',
      author: 'Sarah Johns',
      title: 'Technical Lead, @Amdecs Inc.',
      avatar: 'SJ',
      color: 'amber'
    }
  ];

  return (
    <section id="testimonials" className="testimonials-section">
      <div className="section-container">
        <div className="section-header reveal">
          <div className="section-label">Success Stories</div>
          <h2 className="section-title">Trusted by Customer-Centric Teams</h2>
        </div>
        
        <div className="testimonials-grid">
          {testimonials.map((testimonial, index) => (
            <div key={index} className="testimonial-card reveal">
              <div className="stars">
                {[...Array(testimonial.rating)].map((_, i) => (
                  <FontAwesomeIcon key={i} icon={faStar} />
                ))}
              </div>
              <blockquote>{testimonial.quote}</blockquote>
              <div className="testimonial-author">
                <div className={`avatar ${testimonial.color}`}>
                  {testimonial.avatar}
                </div>
                <div>
                  <div className="author-name">{testimonial.author}</div>
                  <div className="author-title">{testimonial.title}</div>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Testimonials;
